var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 6.5C16.7517 6.5 14.0882 9.16951 14.0882 12.5C14.0882 15.8305 16.7517 18.5 20 18.5C23.2483 18.5 25.9118 15.8305 25.9118 12.5C25.9118 9.16951 23.2483 6.5 20 6.5ZM11.0882 12.5C11.0882 7.54622 15.0615 3.5 20 3.5C24.9385 3.5 28.9118 7.54622 28.9118 12.5C28.9118 17.4538 24.9385 21.5 20 21.5C15.0615 21.5 11.0882 17.4538 11.0882 12.5ZM14.7347 26.5C11.7453 26.5 9.14137 28.5389 8.42439 31.441L7.45622 35.3598C7.25752 36.164 6.44448 36.6549 5.64023 36.4562C4.83598 36.2575 4.34509 35.4445 4.54378 34.6402L5.51195 30.7215C6.55986 26.4799 10.3656 23.5 14.7347 23.5H25.2653C29.6344 23.5 33.4401 26.4799 34.488 30.7214L35.4562 34.6402C35.6549 35.4445 35.164 36.2575 34.3598 36.4562C33.5555 36.6549 32.7425 36.164 32.5438 35.3598L31.5756 31.441C30.8586 28.5389 28.2547 26.5 25.2653 26.5H14.7347Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.1ceeb94800f326fb247aefca9d4aae67.svg";
export { ForwardRef as ReactComponent };